// Types
import { CanGroup, Grouped } from './groupBy.type';

/**
 * Groups the items based on the grouping key and accumulates them in the accumulator object.
 *
 * @template T - The type of the items to be grouped.
 * @param {Grouped<T>} acc - The accumulator object.
 * @param {CanGroup<T>} item - The item to be grouped.
 * @returns {Grouped<T>} The updated accumulator object with the item grouped.
 */
export const grouper = <T>(acc: Grouped<T>, item: CanGroup<T>): Grouped<T> => {
  const groupingKey = item.groupBy;

  acc[groupingKey] = (acc[groupingKey] || []).concat(item.data);

  return acc;
};

/**
 * Groups the items based on the grouping key.
 *
 * @template T - The type of the items to be grouped.
 * @param {CanGroup<T>[]} items - The items to be grouped.
 * @returns {Grouped<T>} The object containing the grouped items.
 */
export const groupBy = <T>(items: CanGroup<T>[]): Grouped<T> => items.reduce<Grouped<T>>(grouper, {});
